var userServiceObj =
{
    getUsers() {
        return axios.get('api/User', { errorHandle: false })
    },
    getUser(id) {
        return axios.get('api/User/' + id, { errorHandle: false })
    },
    saveUser(id, user) {
        console.log('saveUser:' + id + ' Name:' + user.Email)
        return axios.post('api/User', user)
    },
    deleteUser(id) {
        return axios.delete('api/User/' + id)
    },
    //
    getUserRoles() {
        return axios.get('api/User/Roles', { errorHandle: false })
    },
    //
    getMyProfile() {
        return axios.get('api/User/Me', { errorHandle: true })
    },
    //
    getSettings() {
        return axios.get('api/User/Settings', { errorHandle: true })
    },

    getMyMessages(onlyUnread, count) {
        return axios.get('api/User/MyMessages', { params: { onlyUnread: onlyUnread, count: count } })
    },

    roles:
    {
        admin: 'admin',
        operator: 'operator',
        user: 'user'
    }
}

export const userService = userServiceObj;
